<template>
  <Hoxton :revinate_token="revinate_token" :background_image="background_image" :template="template" :portal="portal" :connection_data="connection_data" @emitRegistrationMethodData="handleEmit" />
</template>

<script>
import Hoxton from '@/components/custom/hoxton/index'
export default {
  name: 'custom_template_hoxton_williamsburg',
  props: [ 'template', 'portal', 'connection_data' ],
  components: { Hoxton },
  data(){
    return{
      background_image: `https://sky-production.s3.amazonaws.com/brandportalimages/hox-will-bgimage.jpeg`,
      revinate_token: 'a5600d59-17e3-4028-b787-a021dc597e18'
    }
  },
  methods: {
    handleEmit:function(data){
      this.$emit('emitRegistrationMethodData', data);
    }
  }
}
</script>
<style>
</style>
